/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AfterViewInit, Component, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from 'src/environments/environment';
import { AuthService, ThememodeService } from 'src/app/shared/services';
import { defaultUrlAssets } from './shared/const';
import { iconsSvg } from './shared/const/icons-svg';
import {  Router } from '@angular/router';
import { IntercomChatService } from './shared/services/intercom.chat.service';
import { LoadingCurrentService } from './layout-v3/shared/services/loading-layout-v3.service';
import { routesV3 } from './layout-v3/shared/const/routes-config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'k12-portal';
  loading!: boolean;
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer,
              private thememodeService: ThememodeService,
              private intercomChatService: IntercomChatService,
              private loadingCurrentService: LoadingCurrentService,
              private authService: AuthService, private router: Router,
            private renderer: Renderer2, private _elRef : ElementRef) {     
    const urlAssets = defaultUrlAssets;

    //Call to add hotJar
    this.addHotJarScripts();

    iconsSvg.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
       icon.icon,
       this.domSanitizer.bypassSecurityTrustResourceUrl(urlAssets + icon.url)
      );
    });

    if (sessionStorage.length === 0 || localStorage.length === 0) {
      // Ask other tabs for session storage
      localStorage.setItem('getSessionStorage', JSON.stringify(Date.now()));
    }
 
    if(location?.pathname === "/" || location?.pathname === "/cloudapps"){
      void this.router.navigate([routesV3.cloudapps.route]);
    }

     this.thememodeService.load('v2');
    
    this.loading = false;
    this.loadingCurrentService.isLoading$.subscribe((loading: boolean)=>{
      if( this.authService.isLoggedIn === true){
         this.loading = loading;
      }    
    });
  }

   ngAfterViewInit(): void {
    if(environment.production){
      this.intercomChatService.loadIntercom(environment.intercom.appId);
      /*if(!this.appCuesService.isLoad){
        this.appCuesService.loadScript();
      }*/
    }  
  }

  /**
   * Dynamically adds the Hotjar tracking script to the page head if the Hotjar ID is configured.
   */
  addHotJarScripts(): void {
    // Early return if no Hotjar ID is set in environment (prevents unnecessary operations)
    if (!environment.hotJarId) {
      return;
    }

    // Store the Site ID in sessionStorage – required by Hotjar's custom loader pattern
    sessionStorage.setItem('hotjarId', environment.hotJarId.toString());

    // Get the document head safely (using Renderer2 for Angular compatibility and security)
    const head = this._elRef?.nativeElement?.ownerDocument?.querySelector('head');
    if (!head) {
      console.warn('Could not find document head to append Hotjar script');
      return;
    }

    // Create and configure the script element
    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'type', 'text/javascript');
    this.renderer.setAttribute(script, 'src', 'assets/js/hotjar.js'); 

    // Optional: Add async to load non-blocking (recommended for tracking scripts)
    this.renderer.setAttribute(script, 'async', 'true');

    // Append to head
    this.renderer.appendChild(head, script);
  }

  // Window storage event
 @HostListener('window:storage', ['$event'])
  public onStorage($event: any) {
    if ($event.key === 'getSessionStorage') {
      if (sessionStorage.length === 0) {
        // Ask other tabs for session storage
        localStorage.setItem('getSessionStorage', JSON.stringify(sessionStorage));
      }
      // Some tab asked for the sessionStorage -> send it
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    } else if ( $event.key === 'sessionStorage' && sessionStorage.length === 0) {
       // sessionStorage is empty -> fill it
      const d = localStorage.getItem('sessionStorage');
      const data = JSON.parse(d as string);
      // tslint:disable-next-line:forin
      for (const key in data) {
        sessionStorage.setItem(key, data[key]);
      }
      localStorage.removeItem('sessionStorage');
    }
  }
}
